import { render, staticRenderFns } from "./WhatsApp.vue?vue&type=template&id=ddc6dec6&scoped=true"
import script from "./WhatsApp.vue?vue&type=script&lang=ts"
export * from "./WhatsApp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc6dec6",
  null
  
)

export default component.exports